export const clientCacheDevToolProvider = {
  name: 'ClientCache Manager',
  loadComponent: () => import('./client-cache.dev-tool').then(mod => mod.ClientCacheDevToolComponent)
};
export const modelMetadataDevToolDefinition = {
  name: 'Model Metadata Explorer',
  loadComponent: () => import('./model-metadata-explorer.dev-tool').then(mod => mod.ModelMetadataExplorerDevToolComponent)
};
export const storeInspectorDevToolDefinition = {
  name: 'Store Inspector',
  loadComponent: () => import('./store-explorer/store-explorer.dev-tool').then(mod => mod.StoreExplorerDevToolComponent)
};